module.exports = "/images/social-facebook-light.png?7dc6bb591105e155fdd4435f8ba645d4";